export default __webpack_public_path__ + "static/media/patternEarth.80de0563.svg";